import { useContext } from "react";

import { GaiaMapContext } from "../context/GaiaMapContext";

export const useGaiaMap = (): {
    map: mapboxgl.Map | null;
} => {
    const { mapRef, isMapLoaded } = useContext(GaiaMapContext);
    return {
        map: (isMapLoaded && mapRef?.current) || null,
    };
};
